import React from 'react';
import { ListGroup, ListGroupItem, FormGroup } from 'reactstrap';
import AEAField from '@/components/ui/aea-field/aea-field';
import { IProaTableData } from '@models/*';
import { ProaSummaryPresenter } from '@presenters/screens/proa-summary.presenter';
import style from './detail-data-proa-locations.module.scss';

export interface IProaDetailDataLocationsProps {
    presenter: ProaSummaryPresenter
};

const ProaDetailDataLocations = (props: IProaDetailDataLocationsProps) => {

    return (
        <div>
            <ListGroup>
                <ListGroupItem disabled className={style.item_title}>{props.presenter.currentLabels.get('ZONACCAA')}</ListGroupItem>
                {
                    props.presenter.getLocationsList ?
                        props.presenter.getLocationsList.zonas.map((item: IProaTableData, i: number) =>
                            <ListGroupItem disabled key={i} action className="d-flex justify-content-center">{item.PProaLocation.Title}</ListGroupItem>
                        )
                        : null
                }
            </ListGroup>
            <br />
            <br />
            <ListGroup>
                <ListGroupItem disabled className={style.item_title}>{props.presenter.currentLabels.get('ADT')}</ListGroupItem>
                {
                    props.presenter.getLocationsList ?
                        props.presenter.getLocationsList.adts.map((item: IProaTableData, i: number) =>
                            <ListGroupItem disabled key={i} action className="d-flex justify-content-center">{item.PProaAdt.Title}</ListGroupItem>
                        )
                        : null
                }
            </ListGroup>
            <FormGroup>
                <AEAField  {...props.presenter.commonSelectPropsField}></AEAField>
            </FormGroup>
        </div>
    )
}

export default ProaDetailDataLocations;